import { generateBreadcrumbList } from './utils';
import jsonLdWebSite from './webSite';

export default function getJsonLdWebPage({
  type = 'WebPage',
  name,
  description,
  url,
  mainEntity,
  review,
}) {
  return {
    '@context': 'https://schema.org',
    '@type': type,
    name,
    description,
    url,
    isPartOf: jsonLdWebSite,
    breadcrumb: generateBreadcrumbList(url),
    ...(review ? { review } : {}),
    ...(mainEntity ? { mainEntity } : {}),
  };
}
